import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  FinanceMonthlyPaymentPayload,
  FinanceMonthlyPaymentResponse,
  FinanceOverview,
  FinanceProfileUpdatePayload,
  FinanceProfileUpdateResponse,
} from "~/types/finance";

class FinanceModule extends HttpFactory {
  async getOverview(year: number): Promise<FinanceOverview> {
    return await this.get(ENDPOINTS.FINANCE.OVERVIEW, { year });
  }

  async updateStudentProfile(
    studentId: number,
    payload: FinanceProfileUpdatePayload,
  ): Promise<FinanceProfileUpdateResponse> {
    return await this.patch(
      `${ENDPOINTS.FINANCE.STUDENTS}${studentId}/profile/`,
      payload,
    );
  }

  async upsertStudentMonthlyPayment(
    studentId: number,
    year: number,
    month: number,
    payload: FinanceMonthlyPaymentPayload,
  ): Promise<FinanceMonthlyPaymentResponse> {
    return await this.put(
      `${ENDPOINTS.FINANCE.STUDENTS}${studentId}/months/${year}/${month}/`,
      payload,
    );
  }
}

export default FinanceModule;
